// extracted by mini-css-extract-plugin
export default {"cls1":"UserView-Skeleton_cls1__p5A-I","cls2":"UserView-Skeleton_cls2__XXQC8 UserView-Skeleton_cls1__p5A-I"};